import { gql } from '~/techstyle-shared/react-graphql';

// Reference: https://studio.apollographql.com/graph/fashionos/variant/dev/schema/reference/objects/Query?query=productpricing

/**
 * According to Matt McCabe from the API team,
 * this particular endpoint treats code 3930 and 3925 as vip,
 * all other codes are treated as lead, see full doc of the codes:
 * https://confluence.techstyle.net/display/API/Status+Codes.+ALL+OF+THEM
 * */
export const MEMBERSHIP_STATUS = {
  VIP: 3930,
  PROSPECTIVE: 3926,
};

export const PRICING_QUERY_PRICING_SERVICE_V3 = gql`
  fragment PromoFields on PromoDetails {
    displayOnPdp
    promoCode
    promoLabel
    promoPrice
    promoTypeId
  }

  fragment PricingFields on CustomerProductPrice {
    final
    bogoDetails {
      ...PromoFields
    }
    discountDetails {
      ...PromoFields
    }
    masterProductId
    sales
    vip
    retail
    outlet
    pricingDatasource {
      sourceUrl
      version
    }
  }

  query CioBrowseGridPricingService(
    $masterProductIds: [Int]
    $membershipStatus: Int
  ) {
    productPricing(
      masterProductIds: $masterProductIds
      membershipStatus: $membershipStatus
    ) {
      ...PricingFields
    }
  }
`;

/**
 *
 * Function to fetch Pricing Service data using GraphQL via Apollo client.
 *
 * @param {Object} apolloClient - Apollo client instance
 * @param {Array} masterProductIds - Array of master product IDs
 * @param {boolean} isVip - Flag to indicate if the user is a VIP member
 * @returns {Promise} - Promise that resolves to the pricing data
 */
const getGqlPricingDataPricingServiceV3 = ({
  apolloClient,
  masterProductIds,
  isVip,
}) => {
  const productPricingVariables = {
    masterProductIds: masterProductIds.map((id) => Number(id)),
    membershipStatus: isVip
      ? MEMBERSHIP_STATUS.VIP
      : MEMBERSHIP_STATUS.PROSPECTIVE,
  };

  return apolloClient.query({
    context: {
      clientName: 'supergraph',
      headers: {
        'x-datasource-version': 'pricingServicev3',
      },
    },
    query: PRICING_QUERY_PRICING_SERVICE_V3,
    variables: productPricingVariables,
    errorPolicy: 'all',
  });
};

export default getGqlPricingDataPricingServiceV3;
